import { render } from "./DonorVitalsForm.vue?vue&type=template&id=147f70a0&scoped=true"
import script from "./DonorVitalsForm.vue?vue&type=script&lang=js"
export * from "./DonorVitalsForm.vue?vue&type=script&lang=js"

import "./DonorVitalsForm.vue?vue&type=style&index=0&id=147f70a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147f70a0"]])

export default __exports__